// The one source of time for the app (Q-1: inject clocks, never wait on the wall clock in tests).
export type TimerId = number;

export interface Clock {
  now(): number; // ms, monotonic within the page
  setTimeout(fn: () => void, ms: number): TimerId;
  clearTimeout(id: TimerId): void;
  setInterval(fn: () => void, ms: number): TimerId;
  clearInterval(id: TimerId): void;
}

export const systemClock: Clock = {
  now: () => performance.now(),
  setTimeout: (fn, ms) => window.setTimeout(fn, ms),
  clearTimeout: (id) => window.clearTimeout(id),
  setInterval: (fn, ms) => window.setInterval(fn, ms),
  clearInterval: (id) => window.clearInterval(id),
};

/** A clock that only moves when a test advances it. */
export class FakeClock implements Clock {
  private t = 0;
  private seq = 1;
  private timers = new Map<number, { at: number; fn: () => void; every?: number }>();

  now(): number {
    return this.t;
  }
  setTimeout(fn: () => void, ms: number): TimerId {
    const id = this.seq++;
    this.timers.set(id, { at: this.t + Math.max(0, ms), fn });
    return id;
  }
  clearTimeout(id: TimerId): void {
    this.timers.delete(id);
  }
  setInterval(fn: () => void, ms: number): TimerId {
    const id = this.seq++;
    this.timers.set(id, { at: this.t + ms, fn, every: Math.max(1, ms) });
    return id;
  }
  clearInterval(id: TimerId): void {
    this.timers.delete(id);
  }
  pending(): number {
    return this.timers.size;
  }
  /** Move time forward, firing every due timer in order. */
  advance(ms: number): void {
    const end = this.t + ms;
    for (;;) {
      let next: [number, { at: number; fn: () => void; every?: number }] | undefined;
      for (const e of this.timers) if (e[1].at <= end && (!next || e[1].at < next[1].at)) next = e;
      if (!next) break;
      const [id, timer] = next;
      this.t = timer.at;
      if (timer.every) timer.at += timer.every;
      else this.timers.delete(id);
      timer.fn();
    }
    this.t = end;
  }
}
